export default "__VITE_ASSET__Bh0BSB$W__"